'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _templateObject = _taggedTemplateLiteral(['\n    background-color: ', ';\n    transition: width 200ms ease-in-out;\n    left: 0;\n    ', '\n'], ['\n    background-color: ', ';\n    transition: width 200ms ease-in-out;\n    left: 0;\n    ', '\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n    transition: width 200ms ease-in-out;\n    position:fixed;\n\tbottom:60px;\n\tleft:0;\n\tright:0;\n\tz-index:1000;\n    box-shadow: 2px 0 4px 0 ', ';\n    will-change:transform;\n\ttransform: translateZ(0);\n    ', '\n    justify-content: space-evenly;\n\theight:60px;\n    width: 100vw;\n'], ['\n    transition: width 200ms ease-in-out;\n    position:fixed;\n\tbottom:60px;\n\tleft:0;\n\tright:0;\n\tz-index:1000;\n    box-shadow: 2px 0 4px 0 ', ';\n    will-change:transform;\n\ttransform: translateZ(0);\n    ', '\n    justify-content: space-evenly;\n\theight:60px;\n    width: 100vw;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n    position: relative;\n    height: 60px;\n    display: flex;\n    flex-grow: 1;\n    cursor: pointer;\n    align-items: center;\n    color: ', ';\n    background-color: ', ';\n    ', '\n    ', '\n    ', '\n    ', '\n'], ['\n    position: relative;\n    height: 60px;\n    display: flex;\n    flex-grow: 1;\n    cursor: pointer;\n    align-items: center;\n    color: ', ';\n    background-color: ', ';\n    ', '\n    ', '\n    ', '\n    ', '\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n    position: relative;\n    align-items: center;\n    padding-left: 15px;\n    padding-right: 15px;\n'], ['\n    position: relative;\n    align-items: center;\n    padding-left: 15px;\n    padding-right: 15px;\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n    width: 24px;\n    height: 24px;\n    ', '\n'], ['\n    width: 24px;\n    height: 24px;\n    ', '\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n    display: flex;\n    flex-grow: 1;\n    justify-content: flex-end;\n    align-items: center;\n    gap: 5px;\n'], ['\n    display: flex;\n    flex-grow: 1;\n    justify-content: flex-end;\n    align-items: center;\n    gap: 5px;\n']),
    _templateObject7 = _taggedTemplateLiteral(['\n    display: flex;\n    flex-shrink: 0;\n    justify-content: center;\n    align-items: center;\n    font-family: \'Poppins\', sans-serif;\n    font-size: 12px;\n    font-weight: 600;\n    color: white;\n    width: 18px;\n    height: 18px;\n    border-radius: 50%;\n    ', '\n'], ['\n    display: flex;\n    flex-shrink: 0;\n    justify-content: center;\n    align-items: center;\n    font-family: \'Poppins\', sans-serif;\n    font-size: 12px;\n    font-weight: 600;\n    color: white;\n    width: 18px;\n    height: 18px;\n    border-radius: 50%;\n    ', '\n']),
    _templateObject8 = _taggedTemplateLiteral(['\n  line-height: 14px;\n  ', '\n'], ['\n  line-height: 14px;\n  ', '\n']),
    _templateObject9 = _taggedTemplateLiteral(['\n    cursor: pointer;\n    transition: width 200ms ease-in-out;\n    margin-left: auto;\n    ', '\n    margin-top: auto;\n'], ['\n    cursor: pointer;\n    transition: width 200ms ease-in-out;\n    margin-left: auto;\n    ', '\n    margin-top: auto;\n']),
    _templateObject10 = _taggedTemplateLiteral(['\n    display: none;\n    &:hover{\n        display: block;\n    }\n    ', '\n'], ['\n    display: none;\n    &:hover{\n        display: block;\n    }\n    ', '\n']),
    _templateObject11 = _taggedTemplateLiteral(['\n    ', '\n'], ['\n    ', '\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactIntl = require('react-intl');

var _getColor = require('../../helpers/getColor');

var _getColor2 = _interopRequireDefault(_getColor);

var _getScreenSize = require('../../helpers/getScreenSize');

var _getScreenSize2 = _interopRequireDefault(_getScreenSize);

var _sizes = require('../../constants/sizes');

var _label = require('../../atoms/text/label');

var _label2 = _interopRequireDefault(_label);

var _mobileMenu = require('../../atoms/icons/mobileMenu');

var _mobileMenu2 = _interopRequireDefault(_mobileMenu);

var _colors = require('../../constants/colors');

var _sidebar = require('../sidebar');

var _sidebar2 = _interopRequireDefault(_sidebar);

var _isMobile = require('../../helpers/isMobile');

var _isMobile2 = _interopRequireDefault(_isMobile);

var _isDesktop = require('../../helpers/isDesktop');

var _isDesktop2 = _interopRequireDefault(_isDesktop);

var _container = require('../../layouts/container');

var _container2 = _interopRequireDefault(_container);

var _alignments = require('../../constants/alignments');

var _opacity = require('../../constants/opacity');

var _opacity2 = _interopRequireDefault(_opacity);

var _fi = require('react-icons/fi');

var _error = require('../../atoms/icons/error');

var _error2 = _interopRequireDefault(_error);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var SideTabWrapper = _styledComponents2.default.div(_templateObject, _colors.Colors.LightMode, function (_ref) {
    var desktop = _ref.desktop,
        isCompact = _ref.isCompact,
        collapsed = _ref.collapsed;
    return desktop ? '\n            display: flex;\n            flex-shrink: 0;\n            flex-direction: column;\n            position: sticky;\n            top: 80px;\n            overflow: scroll;\n            box-shadow: 0 2px 4px 0 ' + _colors.Colors.StrokeLight + ';\n            height: calc(100vh - 80px);\n            ' + (collapsed ? 'width: auto;' : 'width: 15vw;') + '\n            ::-webkit-scrollbar {\n\t            width: 0px;\n\t            background-color: ' + _colors.Colors.LightMode + ';\n            }\n            ::-webkit-scrollbar-thumb {\n                border-radius: 20px;\n\t            background-color: ' + _colors.Colors.StrokeLight + ';\n            }\n            ' : '\n            position:fixed;\n            bottom:0;\n\t        right:0;\n\t        z-index:1000;\n            overflow: hidden;\n            box-shadow: 2px 0 4px 0 ' + _colors.Colors.StrokeLight + ';\n            will-change:transform;\n\t        transform: translateZ(0);\n\t        display:flex;\n            justify-content: space-evenly;\n\t        ' + (isCompact ? 'height: 120px; align-items: flex-end;' : 'height: 60px;') + '\n            width: 100vw;\n        ';
});

var CompactSideTab = _styledComponents2.default.div(_templateObject2, _colors.Colors.StrokeLight, function (_ref2) {
    var isCompact = _ref2.isCompact;
    return isCompact ? 'display:flex;' : 'display: none;';
});

var MenuTab = (0, _styledComponents2.default)(_container2.default)(_templateObject3, _colors.Colors.PrimaryText, _colors.Colors.LightMode, function (_ref3) {
    var collapsed = _ref3.collapsed;
    return collapsed ? 'justify-content: center;' : 'justify-content: flex-start;';
}, function (_ref4) {
    var desktop = _ref4.desktop,
        tabWidth = _ref4.tabWidth;
    return !desktop && 'width: ' + tabWidth + 'vw; flex-direction: column;';
}, function (_ref5) {
    var hover = _ref5.hover;
    return hover && 'background: ' + (0, _getColor2.default)(_colors.Colors.Secondary, _opacity2.default.Lighter) + ';';
}, function (_ref6) {
    var active = _ref6.active,
        desktop = _ref6.desktop;
    return active && '\n        transition: width 200ms ease;\n        width: auto;\n        background: ' + (0, _getColor2.default)(_colors.Colors.PrimaryText, _opacity2.default.UltraLight) + ';\n        ::before {\n                content: \'\';\n                position: absolute;\n                ' + (desktop ? '\n                    width: 5px;\n                    height: 100%;\n                    ' : '\n                    width: 100%;\n                    height: 5px;\n                    ') + '\n                left: 0px;\n                border-radius: 3px;\n                background: ' + (0, _getColor2.default)(_colors.Colors.Primary, _opacity2.default.Dark) + ';\n            }\n    ';
});

var MenuContainer = (0, _styledComponents2.default)(_container2.default)(_templateObject4);

var MenuIcon = _styledComponents2.default.div(_templateObject5, function (_ref7) {
    var desktop = _ref7.desktop,
        collapsed = _ref7.collapsed;
    return desktop ? '' + (!collapsed && 'margin-left: 15px;') : 'margin-top: 15px;';
});

var AlertsContainer = _styledComponents2.default.div(_templateObject6);

var AlertBadge = _styledComponents2.default.div(_templateObject7, function (_ref8) {
    var alert = _ref8.alert;

    switch (alert) {
        case 'error':
            return 'background: ' + _colors.Colors.Error + ';';
        case 'warning':
            return 'background: ' + _colors.Colors.Warning + ';';
        default:
            return 'background: ' + _colors.Colors.Success + ';';
    }
});

var MenuLabel = (0, _styledComponents2.default)(_label2.default)(_templateObject8, function (_ref9) {
    var hover = _ref9.hover;
    return hover && 'color: ' + _colors.Colors.Tertiary + ';';
});

var CollapseIcon = _styledComponents2.default.div(_templateObject9, function (_ref10) {
    var collapsed = _ref10.collapsed;
    return collapsed ? 'margin-right: auto;' : 'margin-right: 5px;';
});

var SubMenu = _styledComponents2.default.div(_templateObject10, function (_ref11) {
    var active = _ref11.active,
        collapsed = _ref11.collapsed;
    return active && !collapsed && 'display: block;';
});

var OpenSubMenu = (0, _styledComponents2.default)(_fi.FiChevronDown)(_templateObject11, function (_ref12) {
    var desktop = _ref12.desktop,
        collapsed = _ref12.collapsed;
    return desktop ? '\n        ' + (collapsed ? 'display: none;' : 'margin-left: 15px;') + '\n        margin-bottom: 3px;' : 'display: none;';
});

var NavBar = function NavBar(props) {
    var _useState = (0, _react.useState)(''),
        _useState2 = _slicedToArray(_useState, 2),
        topLevelActiveTab = _useState2[0],
        setTopLevelActiveTab = _useState2[1];

    var _useState3 = (0, _react.useState)(''),
        _useState4 = _slicedToArray(_useState3, 2),
        topLevelHoverTab = _useState4[0],
        setTopLevelHoverTab = _useState4[1];

    var _useState5 = (0, _react.useState)('open'),
        _useState6 = _slicedToArray(_useState5, 2),
        collapseNavItems = _useState6[0],
        setCollapseNavItems = _useState6[1];

    var _useState7 = (0, _react.useState)(false),
        _useState8 = _slicedToArray(_useState7, 2),
        openCompactTabs = _useState8[0],
        setOpenCompactTabs = _useState8[1];

    var screenSize = (0, _getScreenSize2.default)();
    var isDisplayMobile = (0, _isMobile2.default)(screenSize);
    var isDisplayDesktop = (0, _isDesktop2.default)(screenSize);

    var tabs = props.tabs;
    var compactTabs = [];
    if (isDisplayMobile && tabs.length > 4) {
        var menuText = props.intl.formatMessage({ id: 'NavBar.menu' });
        var compactMenu = {
            'code': 'compact',
            'value': 'menu',
            'label': menuText,
            'icon': 'Hamburger'
        };
        tabs = [].concat(_toConsumableArray(props.tabs.slice(0, 3)), [compactMenu]);
        compactTabs = props.tabs.slice(3, 7);
    }
    var tabWidth = 100 / tabs.length;
    var compactTabWidth = 100 / compactTabs.length;
    var IconList = props.IconList;

    (0, _react.useEffect)(function () {
        var tab = null;
        if (window.location) {
            tab = window.location.pathname.slice(1);
        }
        setTopLevelActiveTab(props.defaultTab || tab);
    }, [props.defaultTab]);

    var handleClick = function handleClick(code, value, type) {
        if (code === 'compact') {
            setOpenCompactTabs(!openCompactTabs);
        } else {
            setOpenCompactTabs(false);
            setTopLevelActiveTab(value);
            type === 'menu' ? props.clickEvent(code) : type === 'subMenu' ? props.subMenuClickEvent(code) : '';
        }
    };

    var getIcon = function getIcon(name, color, type) {
        var DisplayIcon = void 0;
        type === 'icon' ? DisplayIcon = IconList && _react2.default.createElement(IconList, { code: name, color: color }) : DisplayIcon = _react2.default.createElement(
            'svg',
            { height: '24', width: '24' },
            _react2.default.createElement('circle', { cx: '12', cy: '12', r: '12', fill: color }),
            _react2.default.createElement(
                'text',
                {
                    fill: _colors.Colors.LightMode,
                    fontSize: '12',
                    textAnchor: 'middle',
                    x: '12',
                    y: '16' },
                name
            )
        );

        return DisplayIcon;
    };

    var getTabValidationInfo = function getTabValidationInfo(tab) {
        var numErrors = 0;
        var numWarnings = 0;
        var isSummaryError = false;
        var isSummaryWarning = false;

        if (props.validationInfo && props.validationInfo.pages && props.validationInfo.pages.length) {
            var pages = props.validationInfo.pages;
            var page = pages.find(function (p) {
                return p.code === tab.code;
            });

            if (page && tab.code === 'summary') {
                isSummaryError = Boolean(page.errors && page.errors.length > 0);
                isSummaryWarning = Boolean(page.warnings && page.warnings.length > 0);
            } else if (page && page.sections.length) {
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = page.sections[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var section = _step.value;
                        var _iteratorNormalCompletion2 = true;
                        var _didIteratorError2 = false;
                        var _iteratorError2 = undefined;

                        try {
                            for (var _iterator2 = section.fields[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                                var field = _step2.value;

                                numErrors += field.errors.length;
                                numWarnings += field.warnings.length;
                            }
                        } catch (err) {
                            _didIteratorError2 = true;
                            _iteratorError2 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                    _iterator2.return();
                                }
                            } finally {
                                if (_didIteratorError2) {
                                    throw _iteratorError2;
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        }
        return { numErrors: numErrors, numWarnings: numWarnings, isSummaryError: isSummaryError, isSummaryWarning: isSummaryWarning };
    };

    var getSectionsValidationInfo = function getSectionsValidationInfo(tab) {
        if (props.validationInfo && props.validationInfo.pages && props.validationInfo.pages.length) {
            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
                for (var _iterator3 = props.validationInfo.pages[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                    var page = _step3.value;

                    if (page.code === tab.code) {
                        var _iteratorNormalCompletion4 = true;
                        var _didIteratorError4 = false;
                        var _iteratorError4 = undefined;

                        try {
                            for (var _iterator4 = page.sections[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                                var section = _step4.value;

                                if (section.errors && section.errors.length > 0) {
                                    return true;
                                }
                            }
                        } catch (err) {
                            _didIteratorError4 = true;
                            _iteratorError4 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion4 && _iterator4.return) {
                                    _iterator4.return();
                                }
                            } finally {
                                if (_didIteratorError4) {
                                    throw _iteratorError4;
                                }
                            }
                        }
                    }
                }
            } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
                        _iterator3.return();
                    }
                } finally {
                    if (_didIteratorError3) {
                        throw _iteratorError3;
                    }
                }
            }
        }
        return false;
    };

    var DisplayTabs = function DisplayTabs(tab, i, tabWidth) {
        var _getTabValidationInfo = getTabValidationInfo(tab),
            numErrors = _getTabValidationInfo.numErrors,
            numWarnings = _getTabValidationInfo.numWarnings,
            isSummaryError = _getTabValidationInfo.isSummaryError,
            isSummaryWarning = _getTabValidationInfo.isSummaryWarning;

        var isSectionErrorExist = getSectionsValidationInfo(tab);

        return _react2.default.createElement(
            _react2.default.Fragment,
            { key: i },
            _react2.default.createElement(
                MenuTab,
                {
                    mouseEnterEvent: function mouseEnterEvent() {
                        return setTopLevelHoverTab(tab.code);
                    },
                    mouseLeaveEvent: function mouseLeaveEvent() {
                        return setTopLevelHoverTab(null);
                    },
                    clickEvent: function clickEvent() {
                        return !tab.disable && handleClick(tab.code, tab.value, 'menu');
                    },
                    verticalAlignment: _alignments.Alignments.center,
                    desktop: isDisplayDesktop,
                    mobile: isDisplayMobile,
                    tabWidth: tabWidth,
                    collapsed: collapseNavItems === 'close',
                    hover: topLevelHoverTab === tab.code,
                    active: topLevelActiveTab === tab.value,
                    inline: true,
                    key: tab.code + '_' + i
                },
                _react2.default.createElement(
                    MenuContainer,
                    { fullWidth: true,
                        verticalAlignment: isDisplayMobile ? _alignments.Alignments.center : _alignments.Alignments.bottom,
                        inline: isDisplayDesktop },
                    _react2.default.createElement(
                        MenuIcon,
                        { desktop: isDisplayDesktop, mobile: isDisplayMobile,
                            collapsed: collapseNavItems === 'close' },
                        tab.icon ? tab.code === 'compact' && openCompactTabs ? _react2.default.createElement(_mobileMenu2.default, {
                            hover: true }) : getIcon(tab.icon, topLevelActiveTab === tab.value ? (0, _getColor2.default)(_colors.Colors.Primary, _opacity2.default.Dark) : tab.disable ? _colors.Colors.StrokeDark : _colors.Colors.DarkMode, 'icon') : getIcon(tab.label[0], topLevelActiveTab === tab.value ? (0, _getColor2.default)(_colors.Colors.Primary, _opacity2.default.Dark) : tab.disable ? _colors.Colors.StrokeDark : _colors.Colors.DarkMode, 'avatar')
                    ),
                    collapseNavItems === 'open' && _react2.default.createElement(MenuLabel, {
                        hover: tab.disable ? false : topLevelHoverTab === tab.code,
                        bold: topLevelActiveTab === tab.value,
                        left: isDisplayDesktop && _sizes.Sizes.sm,
                        right: isDisplayDesktop && _sizes.Sizes.xs,
                        textAlign: _alignments.Alignments.left,
                        text: tab.label,
                        size: isDisplayMobile ? _sizes.Sizes.sm : _sizes.Sizes.md,
                        color: topLevelActiveTab === tab.value ? (0, _getColor2.default)(_colors.Colors.Primary, _opacity2.default.Dark) : tab.disable ? _colors.Colors.StrokeDark : _colors.Colors.DarkMode
                    }),
                    tab.code === 'summary' && isSummaryError ? _react2.default.createElement(
                        AlertsContainer,
                        null,
                        _react2.default.createElement(_error2.default, { mode: 'error', size: 24 })
                    ) : tab.code === 'summary' && isSummaryWarning ? _react2.default.createElement(
                        AlertsContainer,
                        null,
                        _react2.default.createElement(_error2.default, { mode: 'warning', size: 24 })
                    ) : null,
                    (numErrors !== 0 || numWarnings !== 0 || isSectionErrorExist) && tab.code !== 'summary' && _react2.default.createElement(
                        AlertsContainer,
                        null,
                        isSectionErrorExist && collapseNavItems === 'open' && _react2.default.createElement(_error2.default, { mode: 'error', size: 24 }),
                        numErrors !== 0 && collapseNavItems === 'open' && _react2.default.createElement(
                            AlertBadge,
                            { alert: 'error' },
                            numErrors
                        ),
                        numWarnings !== 0 && collapseNavItems === 'open' && _react2.default.createElement(
                            AlertBadge,
                            { alert: 'warning' },
                            numWarnings
                        )
                    ),
                    tab.subMenu && _react2.default.createElement(OpenSubMenu, { size: 15, onClick: function onClick() {
                            return setTopLevelHoverTab(tab.code);
                        },
                        collapsed: collapseNavItems === 'close', desktop: isDisplayDesktop })
                )
            ),
            tab.subMenu && isDisplayDesktop && _react2.default.createElement(
                SubMenu,
                { active: topLevelActiveTab === tab.value, collapsed: collapseNavItems === 'close' },
                _react2.default.createElement(_sidebar2.default, { tabs: tab.subMenu, clickEvent: function clickEvent(e) {
                        return handleClick(e, tab.value, 'subMenu');
                    } })
            )
        );
    };

    return _react2.default.createElement(
        SideTabWrapper,
        { desktop: isDisplayDesktop, collapsed: collapseNavItems === 'close', isCompact: openCompactTabs },
        _react2.default.createElement(
            CompactSideTab,
            { isCompact: openCompactTabs },
            compactTabs.map(function (tab, i) {
                return DisplayTabs(tab, i, compactTabWidth);
            })
        ),
        tabs.map(function (tab, i) {
            return DisplayTabs(tab, i, tabWidth);
        }),
        isDisplayDesktop && _react2.default.createElement(
            CollapseIcon,
            { collapsed: collapseNavItems === 'close' },
            collapseNavItems === 'open' ? _react2.default.createElement(_fi.FiChevronLeft, { size: 25, onClick: function onClick() {
                    return setCollapseNavItems('close');
                } }) : _react2.default.createElement(_fi.FiChevronRight, { size: 25, onClick: function onClick() {
                    return setCollapseNavItems('open');
                } })
        )
    );
};

NavBar.contextTypes = {
    screen: _propTypes2.default.object
};

exports.default = (0, _reactIntl.injectIntl)(NavBar);